import { FC } from 'react'
import { useSelector } from 'react-redux'
import { platformSettingsSlice } from '@wellesley/settings/slices/platformSettingsSlice'
import useFetchPlatformSettings from '@wellesley/settings/hooks/useFetchPlatformSettings'
import { instanceLegalSettingsKeys } from '@wellesley/settings/keys'

import { Markdown } from './Markdown'

export const PrivacyMarkdown: FC = () => {
  useFetchPlatformSettings(instanceLegalSettingsKeys)
  const legal = useSelector(platformSettingsSlice.selectors.selectLegal)

  const privacyPolicyText = legal?.privacyPolicy ?? ''

  return (
    <Markdown markdown={privacyPolicyText} footNotePrefix="footnote-privacy-" />
  )
}
